<template>
  <div id="app" style="overflow-x: hidden;">
    <a v-if="!isLandingPage" href="#" class="back-to-top">
      <i class="fa fa-chevron-up"></i>
    </a>
    <div v-if="!isLandingPage" class="click-closed"></div>
    <NavBar v-if="!isLandingPage" @routerGoTo="routerGoTo" />
    <div v-if="!isLandingPage"></div>
    <router-view @setLandingPage="setLandingPage" style="margin-top: 140px;" />
    <FooterSection v-if="!isLandingPage" />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from './components/shared/navBar.vue'
import FooterSection from './components/shared/footerSection.vue'

export default {
  name: 'app',
  data() {
    return {
      isLandingPage: false,
    }
  },
  components: {
    NavBar,
    FooterSection,
  },

  methods: {
    routerGoTo(goTo) {
      this.$router.push(goTo)
    },
    setLandingPage(item) {
      this.isLandingPage = item
    },
  },
}
</script>

<style>
@import '../public/css/newStyle.css';
button:hover {
  cursor: pointer;
}
hr {
  background-color: #60cbeb;
}
.my-btn {
  margin: 2px;
  color: #60cbeb;
}
.title-img {
  width: 800px;
  height: 400px;
  border-radius: 10px;
}
.title-title {
  opacity: 0.7;
  border: white solid 3px;
  border-radius: 15px;
}
.myBackground {
  border-color: #60cbeb;
  background-color: #60cbeb;
}
.myFill {
  fill: #60cbeb;
  color: #60cbeb;
}
.mySuccess {
  border-color: rgba(2, 184, 117, 0.5);
  background-color: rgba(2, 184, 117, 0.5);
}
.myInfo {
  border-color: rgba(23, 162, 184, 0.5);
  background-color: rgba(23, 162, 184, 0.5);
}
.myWarning {
  border-color: rgba(240, 173, 78, 0.5);
  background-color: rgba(240, 173, 78, 0.5);
}
.myError {
  border-color: rgba(217, 83, 79, 0.5);
  background-color: rgba(217, 83, 79, 0.5);
}
a {
  cursor: pointer;
}
a:hover {
  color: #60cbeb;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
body,
html {
  font-size: 13.7px !important;
  color: #666;
  font-family: 'Roboto', sans-serif;
  height: 100%;
  margin: 0;
}
.isSelected {
  border-color: white white #60cbeb white;
}
.isUnSelected {
  border-color: white white white white;
}
.tabButton {
  display: block;
  padding: 0.5rem 1rem;
  background-color: white;
  border-style: none none solid none;
  width: 100px;
}
.top-left {
  position: centre;
  top: 5px;
  width: 380px;
  color: white;
}
.normalText {
  background-color: #60cbeb;
  color: white;
}
.pendingOffer {
  background-color: #ff8344;
  color: white;
}
.redText {
  background-color: #eb5252;
  color: white;
}
.greenText {
  background-color: #43e243;
  color: white;
}
.noWeeks {
  background-color: #ff4444;
}
.nav-tabs li a {
  border-top: none;
  border-left: none;
  border-right: none;
  margin-left: 10px;
  margin-right: 10px;
  background-color: white;
  border-bottom-color: rgb(27, 117, 187);
  border: 1px solid rgb(27, 117, 187);
}

.nav-tabs li :hover {
  color: white;
  background-color: rgb(27, 117, 187);
}

.nav-tabs li a.active {
  border-top: none;
  border-left: none;
  border-right: none;
  margin-left: 10px;
  margin-right: 10px;
  color: white;
  background-color: rgb(80, 133, 240);
  border-bottom-color: rgb(80, 133, 240);
}

.nav-tabs li a :hover {
  background-color: transparent;
  color: white;
}
</style>

<style scoped>
.pushDown {
  height: 70px;
}
</style>
